module.exports = __webpack_public_path__ + "media/react/pages/answer_reviews/score_report/assets/hand_writing-d224ba90baf377d207a2ec88129c8512.svg";